export interface AiUsage {
    provider: string;
    model: string;
    tokensIn: number;
    tokensOut: number;
}

export interface AiUsageLabels {
    aiLabel: string;
    tokensIn: string;
    tokensOut: string;
}

export function readLabelsFromContainer(el: HTMLElement): AiUsageLabels {
    return {
        aiLabel: el.dataset.locAiLabel ?? 'AI',
        tokensIn: el.dataset.locTokensIn ?? 'in',
        tokensOut: el.dataset.locTokensOut ?? 'out',
    };
}

export function renderAiUsageBadge(usage: AiUsage, labels: AiUsageLabels): string {
    return `<small class="text-muted d-block mt-1">${labels.aiLabel}: ${usage.provider}/${usage.model} &middot; ${usage.tokensIn} ${labels.tokensIn} / ${usage.tokensOut} ${labels.tokensOut}</small>`;
}
